
export default {
  props: {
    primary: { type: Object, required: true },
    openingHourText: { type: Array, required: true },
    showOpeningHours: { type: Boolean, required: true },
  },

  computed: {
    currentDate() {
      let options = { weekday: "long", month: "long", day: "numeric" };

      return new Intl.DateTimeFormat("en-AU", options)
        .format(new Date())
        .replace(",", "");
    },
    currentTradingHours() {
      const currentDay = new Date().getDay();
      const periods = this.primary?.opening_hours?.periods ?? [];
      const openingTime = periods[currentDay]?.open?.time;
      const closingTime = periods[currentDay]?.close?.time;

      return openingTime === closingTime
        ? "Closed"
        : `${openingTime} - ${closingTime}`;
    },
    weeklyTexts() {
      return this.primary?.opening_hours?.weekday_text ?? [];
    },
  },
};
